import React, { useEffect, useState } from 'react'
import { useRouteMatch } from 'react-router-dom'
import algoliasearchHelper from 'algoliasearch-helper'
import { useContentStore } from './useStore'
import { flowResult } from 'mobx'


export function useSearchPageContent(results: algoliasearchHelper.SearchResults) {
  const contentStore = useContentStore()
  const { isExact: isSearchPage } = useRouteMatch('/search') || { isExact: false }
  const [searchPageDeliveryKey, setSearchPageDeliveryKey] = useState<string | null>(null)
  const [pageType, setPageType] = useState<string | null>(null)

  useEffect(() => {
    async function fetchSearchPageContent() {

      setPageType(isSearchPage ? 'SEARCH' : 'OTHER')

      if (!results || !isSearchPage) {
        setSearchPageDeliveryKey(null)
        return
      }

      try {
        // Fetch search page content
        const searchPageContentDeliveryKey = results?.userData?.find(
          (userDataObj: Record<string, unknown>) => userDataObj.searchPageContent
        )
        
        let deliveryKey = null
        if (searchPageContentDeliveryKey?.searchPageContent) {
          // Ensures we have a hyphenated and whitespace free delivery key to fetch from Amplience
          deliveryKey = searchPageContentDeliveryKey?.searchPageContent?.trim().replace(" ", "-")
          setSearchPageDeliveryKey(deliveryKey)
          await flowResult(contentStore.fetchItemByKey(deliveryKey))
        }
        else {
          setSearchPageDeliveryKey(null)
        }

      } catch (error) {
        console.log('Error during setting of search page content', error)
        setSearchPageDeliveryKey(null)
      }
    }

    fetchSearchPageContent()

  }, [results, isSearchPage])

  return { searchPageDeliveryKey, isSearchPage, pageType }
}